(function () {
  var sections = document.querySelectorAll('.oddit-section-ugc');
  if (!sections.length) return;

  var prefersReduced =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  sections.forEach(function (section) {
    var viewport = section.querySelector('.oddit-section-ugc__viewport');
    var track = section.querySelector('.oddit-section-ugc__track');
    var prevBtn = section.querySelector('.oddit-section-ugc__nav--prev');
    var nextBtn = section.querySelector('.oddit-section-ugc__nav--next');
    var indicators = Array.prototype.slice.call(
      section.querySelectorAll('.oddit-section-ugc__indicator')
    );

    if (!viewport || !track) return;

    var originals = Array.prototype.slice.call(
      track.querySelectorAll('.oddit-section-ugc__card')
    );
    var n = originals.length;
    if (!n) return;

    var AUTOPLAY_MS = 5000;
    var TRANSITION = 'transform 0.5s cubic-bezier(0.4, 0, 0.2, 1)';

    // Clone a full set of cards before and after the originals so the row can
    // scroll past either edge and be silently reset for a seamless loop.
    var beforeFrag = document.createDocumentFragment();
    var afterFrag = document.createDocumentFragment();
    originals.forEach(function (card) {
      [beforeFrag, afterFrag].forEach(function (frag, i) {
        var clone = card.cloneNode(true);
        // Clones are decorative duplicates: don't re-run the reveal entrance
        // (which would leave them hidden) and hide them from assistive tech.
        clone.classList.remove('oddit-reveal');
        clone.classList.add('oddit-section-ugc__card--clone');
        clone.setAttribute('aria-hidden', 'true');
        clone.removeAttribute('id');
        (i === 0 ? beforeFrag : afterFrag).appendChild(clone);
      });
    });
    track.insertBefore(beforeFrag, originals[0]);
    track.appendChild(afterFrag);

    // After cloning: clones-before [0..n-1], originals [n..2n-1], clones-after [2n..3n-1].
    var cards = Array.prototype.slice.call(
      track.querySelectorAll('.oddit-section-ugc__card')
    );
    var carousel =
      section.querySelector('.oddit-section-ugc__carousel') || section;
    var index = n + Math.floor(n / 2); // start on the middle real card
    var autoplayTimer = null;
    var hoverPaused = false;
    var focusPaused = false;
    var dragging = false;
    var videoPlaying = false;

    // ---- Video cards --------------------------------------------------------
    // Bound against `cards` (post-clone) rather than `originals`, so the cloned
    // copies either side of the loop play too — otherwise a video would go dead
    // as soon as the carousel wrapped onto a clone.
    function initVideoCard(card) {
      var video = card.querySelector('.oddit-section-ugc__video');
      if (!video) return;

      function state() {
        return card.getAttribute('data-ugc-state') || 'idle';
      }

      // Poster only. Also the `ended` landing state, per the spec: once the clip
      // finishes it returns to its poster rather than freezing on the last frame.
      function toIdle() {
        video.pause();
        video.controls = false;
        video.muted = true;
        video.loop = true;
        video.currentTime = 0;
        card.setAttribute('data-ugc-state', 'idle');
        videoPlaying = false;
        scheduleNext();
      }

      // Silent looping hover preview. No controls, and the card keeps the click
      // so a click promotes the preview into real playback.
      function toPreview() {
        if (state() === 'playing') return;
        video.controls = false;
        video.muted = true;
        video.loop = true;
        card.setAttribute('data-ugc-state', 'preview');
        var started = video.play();
        // Blocked autoplay: fall back to the poster rather than leaving a
        // transparent hole where the video should be.
        if (started && started.catch) {
          started.catch(function () {
            if (state() === 'preview') card.setAttribute('data-ugc-state', 'idle');
          });
        }
      }

      // A real watch: native controls, sound on, plays once through. The click
      // is a user gesture, so unmuted play() is permitted here.
      function toPlaying() {
        video.controls = true;
        video.muted = false;
        // Set before unmuting takes audible effect, so it never bursts in at
        // full volume. The native controls let the viewer take it from here.
        video.volume = 0.3;
        video.loop = false;
        video.currentTime = 0;
        card.setAttribute('data-ugc-state', 'playing');
        videoPlaying = true;
        scheduleNext();
        var started = video.play();
        if (started && started.catch) {
          started.catch(function () { toIdle(); });
        }
      }

      // Hover is a pointer affordance only; touch devices fall through to click.
      if (!prefersReduced) {
        card.addEventListener('mouseenter', toPreview);
        card.addEventListener('mouseleave', function () {
          // Never yank a video the visitor is actually watching.
          if (state() === 'playing') return;
          toIdle();
        });
      }

      card.addEventListener('click', function (e) {
        // The username chip is a real link — let it navigate.
        if (e.target.closest && e.target.closest('.oddit-section-ugc__username--link')) return;
        // Once controls are up they own every click inside the media element:
        // play/pause, scrub, volume, fullscreen. Don't second-guess them.
        if (state() === 'playing') return;
        toPlaying();
      });

      video.addEventListener('ended', toIdle);
    }

    cards.forEach(function (card) {
      if (card.hasAttribute('data-ugc-video')) initVideoCard(card);
    });

    function centerOffset(i) {
      var card = cards[i];
      if (!card) return 0;
      var cardCenter = card.offsetLeft + card.offsetWidth / 2;
      return viewport.clientWidth / 2 - cardCenter;
    }

    function apply(animate) {
      track.style.transition = animate ? TRANSITION : 'none';
      track.style.transform =
        'translate3d(' + centerOffset(index) + 'px, 0, 0)';
    }

    function realIndex() {
      return (((index - n) % n) + n) % n;
    }

    function updateIndicators() {
      if (!indicators.length) return;
      var ri = realIndex();
      indicators.forEach(function (dot, i) {
        var active = i === ri;
        dot.classList.toggle('oddit-section-ugc__indicator--active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    function go(delta) {
      index += delta;
      apply(true);
      updateIndicators();
      scheduleNext();
    }

    // Once a slide animation lands in a clone zone, jump (no animation) to the
    // equivalent real card so the loop can continue forever without a visible seam.
    track.addEventListener('transitionend', function (e) {
      if (e.propertyName !== 'transform') return;
      if (index >= 2 * n) {
        index -= n;
        apply(false);
      } else if (index < n) {
        index += n;
        apply(false);
      }
    });

    // Self-resetting timer: every advance or interaction restarts a full
    // countdown, so the carousel always waits AUTOPLAY_MS after the last action.
    function scheduleNext() {
      window.clearTimeout(autoplayTimer);
      // `videoPlaying` matters on touch, where there's no hover to pause on:
      // the carousel must not slide a video out from under the viewer.
      if (prefersReduced || hoverPaused || focusPaused || dragging || videoPlaying) return;
      autoplayTimer = window.setTimeout(function () { go(1); }, AUTOPLAY_MS);
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { go(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { go(1); });

    indicators.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        index = n + i;
        apply(true);
        updateIndicators();
        scheduleNext();
      });
    });

    // Pause autoplay only while the pointer is over a card or an arrow (not the
    // whole section), so it keeps cycling over empty carousel space.
    function onCardOrNav(el) {
      return !!(
        el &&
        el.closest &&
        (el.closest('.oddit-section-ugc__card') ||
          el.closest('.oddit-section-ugc__nav'))
      );
    }

    carousel.addEventListener('mouseover', function (e) {
      if (onCardOrNav(e.target)) {
        hoverPaused = true;
        scheduleNext();
      }
    });
    carousel.addEventListener('mouseout', function (e) {
      if (!onCardOrNav(e.relatedTarget)) {
        hoverPaused = false;
        scheduleNext();
      }
    });

    // Pause while a control inside the carousel is keyboard-focused.
    carousel.addEventListener('focusin', function () {
      focusPaused = true;
      scheduleNext();
    });
    carousel.addEventListener('focusout', function () {
      focusPaused = false;
      scheduleNext();
    });

    // Live pointer drag (mouse + touch + pen): the track follows the pointer in
    // real time and snaps to the nearest card on release.
    var dragStartX = 0;
    var dragBase = 0;
    var dragDelta = 0;

    function cardStep() {
      var next = cards[index + 1] || cards[index];
      return Math.abs(next.offsetLeft - cards[index].offsetLeft) ||
        cards[index].offsetWidth;
    }

    // A press only becomes a drag once it travels past this. Below it, the
    // gesture stays a plain click so the username link still works.
    var DRAG_THRESHOLD = 5;
    var pointerDown = false;
    var dragMoved = false;
    var activePointerId = null;

    viewport.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      // A playing video takes pointer-events, so a press landing on it is aimed
      // at the native controls — scrubbing must not drag the carousel.
      if (e.target.closest && e.target.closest('.oddit-section-ugc__video')) return;
      pointerDown = true;
      dragMoved = false;
      dragging = false;
      activePointerId = e.pointerId;
      dragStartX = e.clientX;
      dragBase = centerOffset(index);
      dragDelta = 0;
    });

    viewport.addEventListener('pointermove', function (e) {
      if (!pointerDown) return;
      var dx = e.clientX - dragStartX;

      if (!dragMoved) {
        if (Math.abs(dx) < DRAG_THRESHOLD) return;
        // Only now do we claim the pointer. Capturing on pointerdown would
        // retarget the subsequent `click` to the viewport, so the anchor inside
        // the card would never receive it and the link would be dead.
        dragMoved = true;
        dragging = true;
        track.style.transition = 'none';
        viewport.classList.add('oddit-section-ugc__viewport--dragging');
        scheduleNext();
        try { viewport.setPointerCapture(e.pointerId); } catch (err) {}
      }

      dragDelta = dx;
      track.style.transform =
        'translate3d(' + (dragBase + dragDelta) + 'px, 0, 0)';
    });

    function endDrag(e) {
      if (!pointerDown) return;
      pointerDown = false;

      if (activePointerId != null) {
        try { viewport.releasePointerCapture(activePointerId); } catch (err) {}
        activePointerId = null;
      }

      // A press that never crossed the threshold is a click, not a drag —
      // leave the track where it is and let the click through.
      if (!dragging) return;

      dragging = false;
      viewport.classList.remove('oddit-section-ugc__viewport--dragging');
      var step = cardStep();
      var shift = step ? -Math.round(dragDelta / step) : 0;
      // Never travel further than the cloned buffer in one gesture.
      if (shift > n) shift = n;
      if (shift < -n) shift = -n;
      index += shift;
      apply(true);
      updateIndicators();
      scheduleNext();
    }

    viewport.addEventListener('pointerup', endDrag);
    viewport.addEventListener('pointercancel', endDrag);

    // Swallow the synthetic click that ends a real drag, so releasing a swipe
    // over the username chip doesn't navigate.
    viewport.addEventListener('click', function (e) {
      if (dragMoved) {
        e.preventDefault();
        e.stopPropagation();
        dragMoved = false;
      }
    }, true);

    // Recenter (without animation) when the viewport width changes.
    var resizeRAF = null;
    window.addEventListener('resize', function () {
      if (resizeRAF) cancelAnimationFrame(resizeRAF);
      resizeRAF = requestAnimationFrame(function () { apply(false); });
    });

    apply(false);
    updateIndicators();
    scheduleNext();

    // Re-center once late-loading assets have settled the layout.
    window.addEventListener('load', function () { apply(false); });
  });
})();
